"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DROPDOWN CONTROLS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)


var _default = {
  dropdownitemcontrols: {
    // display: 'flex',
    // position: 'absolute',
    // right: 0,
    '& .itemcontrol': {
      display: 'inline-flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      fontSize: (0, _index.pxToEmWithBaseline)({
        value: 12,
        fontSizeBaseline: 14
      }),
      color: '#8295ba',
      height: (0, _index.pxToEmWithBaseline)({
        value: 20,
        fontSizeBaseline: 12
      }),
      width: (0, _index.pxToEmWithBaseline)({
        value: 20,
        fontSizeBaseline: 12
      }),
      border: 'none',
      borderRadius: (0, _index.pxToEmWithBaseline)({
        value: 4,
        fontSizeBaseline: 12
      }),
      cursor: 'pointer',
      transition: 'all .5s ease-in 0s',
      '&:hover': {
        backgroundColor: '#f2f4f8',
        transition: 'background-color 0.5s ease'
      }
    }
  }
};
exports.default = _default;